import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'semantic-ui-react';

import styles from './InfoCard.module.scss';

const InfoCardDevice = React.memo(({ componentItem, devices, items, desc, children }) => {
  let i = 0;

  return (
    <Card className={styles.cardDeviceItem}>
      <Card.Content className={styles.cardContent}>
        {children}
        <Card.Header className={styles.cardHeader}>{componentItem.title}</Card.Header>
        <Card.Description className={`font-semibold text-lg ${styles.cardDesc}`}>
          {componentItem.values?.map((item) => {
            if (items.length > 0 && devices.length > 0) {
              i += 1;
              const { itemName } = items.find((itemItem) => itemItem.name === item.name);
              let deviceValue = item.value ? item.value : 0;
              const deviceData = devices.find((device) => device.id === componentItem.deviceId);
              if (deviceData && deviceData.items && deviceData.items?.[itemName]) {
                deviceValue = deviceData.items[itemName];
              }
              deviceValue = item.decimalPoint
                ? parseFloat(deviceValue).toLocaleString('en-GB', {
                    minimumFractionDigits: item.decimalPoint,
                    maximumFractionDigits: item.decimalPoint,
                  })
                : deviceValue;
              return (
                <div key={i} className={styles.cardInfo}>
                  <span className={styles.cardValue}>{deviceValue}</span>
                  <span className={styles.cardUnit}>{item.unitName}</span>
                </div>
              );
            }
            return '';
          })}
        </Card.Description>
        <Card.Description className={styles.cardDesc}>{desc}</Card.Description>
      </Card.Content>
    </Card>
  );
});

InfoCardDevice.propTypes = {
  componentItem: PropTypes.objectOf(PropTypes.any).isRequired,
  desc: PropTypes.string,
  children: PropTypes.element,
  devices: PropTypes.arrayOf(PropTypes.any).isRequired,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
};

InfoCardDevice.defaultProps = {
  desc: undefined,
  children: undefined,
};

export default InfoCardDevice;
